'use client'

import { SessionProvider } from './SessionProvider'
import { UserProvider } from '@/contexts/UserContext'
import { NotificationProvider } from '@/contexts/NotificationContext'
import { ToastProvider } from '@/components/ui/ToastContainer'
import { ConfirmProvider } from '@/components/ui/dialog'
import { DynamicTitle } from '@/components/DynamicTitle'
import { DynamicFavicon } from '@/components/DynamicFavicon'
import { I18nProvider } from './I18nProvider'
import { LanguageProvider } from './LanguageProvider'
import { CacheManager } from '@/components/CacheManager'

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <SessionProvider>
      <I18nProvider>
        <LanguageProvider>
          <UserProvider>
            <NotificationProvider>
              <ToastProvider>
                <ConfirmProvider>
                  <DynamicTitle />
                  <DynamicFavicon />
                  <CacheManager />
                  {children}
                </ConfirmProvider>
              </ToastProvider>
            </NotificationProvider>
          </UserProvider>
        </LanguageProvider>
      </I18nProvider>
    </SessionProvider>
  )
} 